import { useQuery } from '@tanstack/react-query';

import useApi from './use-api';

import type { IWeatherResponse } from 'infrastructure/interfaces';

interface IProps {
  city?: string | null;
  state?: string | null;
  canLoad?: boolean;
}

export const useWeather = (props: IProps) => {
  const { city, state, canLoad } = props;

  const { loadData } = useApi({
    showError: false,
  });

  const queryKey = ['getWeather', city, state];

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: async () => {
      const res = await loadData<IWeatherResponse>('core-2/weather', {
        city,
        state,
      });

      if (res) {
        return res;
      }

      return undefined;
    },
    enabled: canLoad && Boolean(city && state),
    staleTime: 1000 * 5 * 60,
  });

  return {
    data,
    isLoading,
  };
};
